import { afterNextRender, Component, HostListener, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router, RouterLink } from '@angular/router';
import { filter, Subscription } from 'rxjs';

import { ConviviaLogoComponent } from '@core/component/convivia-logo/convivia-logo.component';
import { DemoService } from 'src/app/core/service/demo.service';
import { AnalyticsService } from '@core/service/analytics.service';

@Component({
  selector: 'app-landing-nav',
  standalone: true,
  imports: [CommonModule, ConviviaLogoComponent, RouterLink],
  templateUrl: './main-nav.component.html',
})
export class MainNavComponent implements OnInit, OnDestroy {
  isScrolled = false;
  solidNav = false;
  mobileNavOpen = false;
  navHeight = 60;

  private readonly isBrowser: boolean;
  private readonly routerSub: Subscription;

  constructor(
    @Inject(PLATFORM_ID) platformId: object,
    private readonly demoService: DemoService,
    private readonly analytics: AnalyticsService,
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    this.routerSub = this.router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe(() => {
      this.solidNav = this.readSolidNav();
    });

    afterNextRender(() => {
      if (this.isBrowser) {
        this.isScrolled = window.scrollY > 50;
      }
    });
  }

  public ngOnInit(): void {
    this.solidNav = this.readSolidNav();
  }

  public ngOnDestroy(): void {
    this.routerSub.unsubscribe();
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (this.isBrowser) {
      this.isScrolled = window.scrollY > 50;
    }
  }

  @HostListener('window:resize', [])
  onWindowResize() {
    if (this.isBrowser && window.innerWidth >= 768) {
      this.mobileNavOpen = false;
    }
  }

  toggleMobileNav() {
    this.mobileNavOpen = !this.mobileNavOpen;
  }

  openDemoForm(): void {
    const source = 'main_nav';
    this.analytics.trackEvent('demo_open', { source });
    this.demoService.open(source);
  }

  private readSolidNav(): boolean {
    let route = this.activatedRoute.root;
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route.snapshot.data['navigation']?.solidNavigation === true;
  }
}
